import React, { Component, Suspense } from 'react';
import { Route, withRouter, Switch, Redirect } from 'react-router-dom';
import { connect } from 'react-redux';

import AppLayout from '../../layout/AppLayout';

const TransportationCompanyMain = React.lazy(() =>
    import(/* webpackChunkName: "viwes-blank-page" */ '../mains/transportationcompany-main')
);

class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      spinner: true
    }
  }

  // showSpinner = () => {
  //   this.setState({spinner: true});
  // };
  // hideSpinner = () => {
  //   this.setState({spinner: false});
  // };

  render() {
    const {match} = this.props;

    return (
        <AppLayout>
          <div className="dashboard-wrapper">
            <Suspense fallback={<div className="loading"/>}>
              <Switch>
                <Route
                    exact
                    path={`/`}
                            render={props => <TransportationCompanyMain {...props}
                                                     showSpinner={this.props.showSpinner}
                                                     hideSpinner={this.props.hideSpinner}
                                                     showAlert={this.props.showAlert}
                                                     alertClose={this.props.alertClose}
                                                     showSweetAlert={this.props.showSweetAlert}
                                                     closeSweetAlert={this.props.closeSweetAlert}
                                      />
                    }
                />
              </Switch>
            </Suspense>
          </div>
        </AppLayout>
    );
  }
}
const mapStateToProps = ({ menu }) => {
  const { containerClassnames } = menu;
  return { containerClassnames };
};

export default withRouter(
  connect(
    mapStateToProps,
    {}
  )(App)
);
